export default "<p-confirmDialog header=\"Confirmation\"></p-confirmDialog>\n<router-outlet></router-outlet>\n"